var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "auth hero is-fullheight" }, [
    _c("div", { staticClass: "hero-body is-centered" }, [
      _c("div", { staticClass: "container is-centered" }, [_c("RouterView")], 1)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }